import './App.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTelegram, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { EffectCoverflow, Pagination, Autoplay } from 'swiper'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from './components/LanguageSwitcher'

function App() {
  const { t } = useTranslation() // Use the hook
  return (
    <div className='main'>
      <div className='logo_container'>
        <LanguageSwitcher />
        <img className='logo' src={require('./images/logo.png')} alt='logo' />
      </div>
      <div className='content'>
        <div className='content_top'>
          <p>
            {t('introduction1')}
            <br />
            <br />
            {t('introduction2')}
            <br />
            <br />
            {t('introduction3')}
            <br />
            <br />
            {t('introduction4')}
            <br />
            <br />
            {t('introduction5')}
          </p>
          <div className='top_bottom'>
            <div className='join_container'>
              <div className='join_left'>
                <p className='join_left_top'>{t('join')}</p>
                <br/>
                <p className='join_left_bottom'>{t('open0')}</p>
                <p className='join_left_bottom'>{t('open1')}</p>
                <p className='join_left_bottom'>{t('open2')}</p>
                <br/>
                <p className='join_left_bottom'>{t('subjoin0')}</p>
                <p className='join_left_bottom'>{t('subjoin')}</p>
              </div>
              <div className='join_right'>
                <img className='qr' src={require('./images/qr.png')} alt='qr' />
              </div>
            </div>

            <div className='contact_container'>
              <p className='contactTitle'>{t('contactTitle')}</p>

              <div class='networks'>
                <div class='netbox'>
                  <a
                    class='icon'
                    href='https://t.me/borz_creed'
                    target='_blank'
                    rel='noreferrer'
                    data-for='tooltip'
                    data-tip={t('pack')}
                  >
                    <FontAwesomeIcon className='faicon' icon={faTelegram} />
                  </a>
                  <a
                    class='icon'
                    href='https://www.instagram.com/borz_creed/'
                    target='_blank'
                    rel='noreferrer'
                    data-for='tooltip'
                    data-tip={t('witness')}
                  >
                    <FontAwesomeIcon className='faicon' icon={faInstagram} />
                  </a>
                  <a
                    class='icon'
                    href='mailto:borzcreed@gmail.com'
                    data-for='tooltip'
                    data-tip={t('question')}
                  >
                    <FontAwesomeIcon className='faicon' icon={faEnvelope} />
                  </a>
                  <a
                    class='icon'
                    href='tel:+4915906474343'
                    data-for='tooltip'
                    data-tip={t('call')}
                  >
                    <FontAwesomeIcon className='faicon' icon={faPhone} />
                  </a>
                </div>
              </div>
              {/*  <ul>
                <li class='tg'>
                  <a href='https://t.me/borz_creed'
                  target='_blank'
                  rel='noreferrer'>
                    <FontAwesomeIcon className='faicon' icon={faTelegram} />
                  </a>
                </li>
                <li class='in'>
                  <a href='https://www.instagram.com/borz_creed/'>
                    <FontAwesomeIcon className='faicon' icon={faInstagram} />
                  </a>
                </li>
                <li class='ma'>
                  <a href='mailto:borzcreed@gmail.com'>
                    <FontAwesomeIcon className='faicon' icon={faEnvelope} />
                  </a>
                </li>
                <li class='te'>
                  <a href='tel:+4915906474343'>
                    <FontAwesomeIcon className='faicon' icon={faPhone} />
                  </a>
                </li>
              </ul> */}
              {/* <div className='telegram'>
                <p>Telegram</p>
                <a
                  href='https://t.me/borz_creed'
                  target='_blank'
                  rel='noreferrer'
                >
                  <p className='cursive'> @borz_creed</p>
                </a>
              </div>
              <div className='phone'>
                <p>Phone</p>
                <a href='tel:+4915906474343'>
                  <p className='cursive'>+49 159 064 74343</p>
                </a>
              </div>
              <div className='email'>
                <p>Mail</p>
                <a href='mailto:borzcreed@gmail.com'>
                  <p className='cursive'> borzcreed@gmail.com </p>
                </a>
              </div>
              <div className='insta'>
                <p>Instagram</p>
                <a href='https://www.instagram.com/borz_creed/'>
                  <p className='cursive'> borz_creed </p>
                </a>
              </div> */}
            </div>
          </div>
        </div>
        <div className='content_middle'>
           <div className='address'>
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2426.442022423126!2d13.439999976993118!3d52.543528934487036!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a84d47512a87b7%3A0x3d83e46f9ae67c85!2sMMA%20CLUB%20BORZ!5e0!3m2!1sen!2sde!4v1692197763022!5m2!1sen!2sde'
              width='1600'
              height='400'
              allowfullscreen=''
              loading='lazy'
              referrerpolicy='no-referrer-when-downgrade'
              title='borz'
            ></iframe>
          </div>
          <div className='content_middle_video'>
          <iframe width="494" height="879" src="https://www.youtube.com/embed/btCJ6xsxWKU" title="The only decision is made by god, in Thee I trust and in Thee rely those who believe." frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          <iframe width="494" height="879" src="https://www.youtube.com/embed/33a5JmgQnXI" title="🐺 or 🐑 ?" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
          <div className='slogan'>{t('unleash')}</div>
          <Swiper
            effect={'coverflow'}
            grabCursor={true}
            initialSlide={1}
            centeredSlides={true}
            spaceBetween={-20}
            slidesPerView={'auto'}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true,
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={true}
            modules={[EffectCoverflow, Pagination, Autoplay]}
            className='mySwiper'
          >
            <SwiperSlide>
              <img src={require('./images/cazzotti_0.webp')} alt='Borz0' />
            </SwiperSlide>
            <SwiperSlide>
              <img src={require('./images/cazzotti_1.webp')} alt='Borz1' />
            </SwiperSlide>
            <SwiperSlide>
              <img src={require('./images/cazzotti_2.webp')} alt='Borz2' />
            </SwiperSlide>
          </Swiper>
        </div>
        <div className='content_bottom'>
          <div className='footer'>
            <p>
              © {new Date().getFullYear()} Borz - Powered by{' '}
              <a
                href='https://raffaelli.studio'
                target='_blank'
                rel='noreferrer'
              >
                Raffaelli.Studio
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default App
